import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { IGenericApiResponse } from "src/app/models/common/GenericApiResponse";
import { WorkflowRequestTypes } from "src/app/models/requests/enums/WorkflowRequestTypes.enum";
import { IWorkflowReview, IWorkflowRequest } from "src/app/models/requests/WorkflowRequest";
import { IdampHttpClient } from "../common/IdampHttpClient";
import { ChangeRequestApprovers } from "src/app/models/requests/ChangeRequestApprovers";
import { FilterRequestAge } from "src/app/models/requests/enums/FilterRequestAge.enum";
import { NumberOfMonths } from "src/app/models/charts/by-request-type/numberOfMonths.enum";
import { WorkflowStates } from "src/app/models/requests/enums/WorkflowStates.enum";

@Injectable({ providedIn: 'root' })

export class WorkflowRequestService {

    constructor(private http: IdampHttpClient) { }

    public GetByApprover(filterRequestAge: FilterRequestAge = FilterRequestAge.Last3Months): Observable<IGenericApiResponse<IWorkflowRequest[]>> {
        const path = `me/approvals`;
        const queryParams = {
            filterRequestAge: filterRequestAge
        };
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest[]>>(path, queryParams));
    }

    public GetByRequestor(filterRequestAge: FilterRequestAge = FilterRequestAge.Last3Months): Observable<IGenericApiResponse<IWorkflowRequest[]>> {
        const path = `me/requests`;
        const queryParams = {
            filterRequestAge: filterRequestAge
        };
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest[]>>(path, queryParams));
    }

    public GetByType(type: WorkflowRequestTypes, numberOfMonths: NumberOfMonths = NumberOfMonths.LastThreeMonths): Observable<IGenericApiResponse<IWorkflowRequest[]>> {
        const path = `requests/byType/${type}`;
        const queryParams = {
            numberOfMonthsBack: numberOfMonths
        };
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest[]>>(path, queryParams));
    }

    public GetByState(state: WorkflowStates, numberOfMonths: NumberOfMonths = NumberOfMonths.LastThreeMonths): Observable<IGenericApiResponse<IWorkflowRequest[]>> {
        const path = `requests/byState/${state}`;
        const queryParams = {
            numberOfMonthsBack: numberOfMonths
        };
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest[]>>(path, queryParams));
    }

    public GetById(type: WorkflowRequestTypes, id: string): Observable<IGenericApiResponse<IWorkflowRequest>> {
        const path = `request/${type}/${id}`;
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest>>(path));
    }

    public ReviewRequest(type: WorkflowRequestTypes, id: string, approved: boolean, comment: string, issueNumber?: string): Observable<IGenericApiResponse<IWorkflowReview>> {
        const path = `request/${type}/${id}/review`;
        const payload: IWorkflowReview = { approved, comment, issueNumber };
        return from(this.http.PatchAsync<IWorkflowReview, IGenericApiResponse<IWorkflowReview>>(path, payload));
    }

    public CancelRequest(type: WorkflowRequestTypes, id: string): Observable<IGenericApiResponse<IWorkflowRequest>> {
        const path = `request/${type}/${id}/cancel`;
        return from(this.http.PostAsync<null, IGenericApiResponse<IWorkflowRequest>>(path, null));
    }

    public UpdateRequestApprovers(type: WorkflowRequestTypes, id: string, model: ChangeRequestApprovers): Observable<IGenericApiResponse<IWorkflowRequest>> {
        const path = `request/${type}/${id}/update-approvers`;
        return from(this.http.PatchAsync<ChangeRequestApprovers, IGenericApiResponse<IWorkflowRequest>>(path, model));
    }

    public GetRequestsByRequestorId(requestorId: string, filterRequestAge: FilterRequestAge = FilterRequestAge.Last3Months): Observable<IGenericApiResponse<IWorkflowRequest[]>> {
        const path = `request/${requestorId}`;
        const queryParams = {
            filterRequestAge: filterRequestAge
        };
        return from(this.http.GetAsync<IGenericApiResponse<IWorkflowRequest[]>>(path, queryParams));
    }
}